<script>
  import Container from '@/library/container/full-centre.svelte';

  export let service;

  // let layout = service.layout;
  // let pretext = service.content.pretext;
  // let context = service.content.context;
  // let subtext = service.content.subtext;
  let meta = service.meta;
</script>

<style></style>

<section id="redirect" class="py-lg bg-green-700">
  <Container>
    <div class="fc ic jc tc">
      <div class="max-w-md sm:max-w-lg lg:max-w-none px-md py-md">
        <p class="text-xl sm:text-2xl text-white leading-relaxed">
          For residential enquiries,
          <a href={meta.redirect.link} target="_blank" rel="noopener noreferrer" class="underline">
            {meta.redirect.text}
          </a>
        </p>
      </div>
    </div>
  </Container>
</section>